export const removeNullElements = (array) => array && Array.isArray(array) ? array.filter(i => i !== null && typeof i !== 'undefined') : array;